const userLabel = require("../label/user");

const note_comment_mention = {
  key: "note_comment_mention",
  count_alias: "count_comment_mentions_new",
  label_activity: "comment mentions",
  label_data: "new comment mention",
  label_detail: "A user mentions me in a comment.",
  label_title: () => "New Comment Mention",
  label_zero_state:
    "When a user mentions you in a comment, we'll notify you here.",
  makeNote: (user) => userLabel(user) + " mentioned you in a comment.",
  makeLink: ({ comment_id }) => "/comment/" + comment_id,
  table: "comment_mention",
  leftJoins: ["comment", "comment_author"],
  keys: [
    "comment_mention.id AS id",
    "comment_mention.created_at AS noted_at",
    "comment.id AS comment_id",
    "comment_author.username AS username",
    "comment_author.display_name AS display_name",
  ],
  wheres: ["comment_mention.username = ?", "comment.author_id <> ?"],
  where_since: {
    index: 1,
    sql: "comment_mention.created_at >= ?",
    key: "note_last",
  },
  escapeValues: (user) => [user.username, user.id],
};

module.exports = note_comment_mention;
